import { SetterOrUpdater } from 'recoil';
import * as yaml from 'js-yaml';
import { S3File } from 'features/file-browser/state/fileAtoms';
import { AppConfig } from 'features/optimization/state/appConfigAtoms';
import { CFDConfig } from 'features/optimization/state/cfdConfigAtoms';
import { Parameter } from 'features/morphing/state/parameterAtoms';

export const importFile = (
  event: React.ChangeEvent<HTMLInputElement>,
  allModels: S3File[],
  setDisplayModel: SetterOrUpdater<S3File | null>,
  setAppConfig: SetterOrUpdater<AppConfig>,
  setCFDConfig: SetterOrUpdater<CFDConfig>,
  setParameterList: SetterOrUpdater<Parameter[]>
) => {
  const file = event.target.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const yamlData = e.target?.result as string;
        const config = yaml.load(yamlData) as any; // Cast as 'any' to handle YAML structure

        if (config) {
          // Find the display model by path from allModels
          const displayModel = allModels.find(model => model.path === config.application.base_stl);
          if (displayModel) {
            setDisplayModel(displayModel);
          } else {
            alert('指定された車体モデルが見つかりません。');
            setDisplayModel(null);
          }

          // Set the app configuration
          setAppConfig({
            name: config.application.name,
            studyName: config.application.study_name,
            nParallels: config.application.n_parallels as number,
            nTrials: config.application.n_trials as number,
            maxDesignSpace: {
              x: config.application.design_space.max[0],
              y: config.application.design_space.max[1],
              z: config.application.design_space.max[2]
            },
            minDesignSpace: {
              x: config.application.design_space.min[0],
              y: config.application.design_space.min[1],
              z: config.application.design_space.min[2]
            }
          });

          // Set the CFD configuration
          setCFDConfig({
            carType: config.cfd.car_type,
            openfoamVersion: config.cfd.openfoam_version,
            model: config.cfd.cfd_model,
            velocity: config.cfd.velocity as number,
            note: config.cfd.note
          });

          // Set the morphing parameters
          setParameterList(
            config.application.morphing_parameters.map((p: any) => ({
              name: p.name,
              controlPoints: {
                x: p.control_points[0],
                y: p.control_points[1],
                z: p.control_points[2]
              },
              morphingMin: {
                x: p.bbox_origin[0],
                y: p.bbox_origin[1],
                z: p.bbox_origin[2]
              },
              morphingMax: {
                x: p.bbox_origin[0] + p.bbox_length[0],
                y: p.bbox_origin[1] + p.bbox_length[1],
                z: p.bbox_origin[2] + p.bbox_length[2]
              },
              ySymmetry: p.y_symmetry as boolean,
              targetControlPointsX: {
                start: p.target_control_points[0].x[0] + 1,
                stop: p.target_control_points[0].x[1],
              },
              targetControlPointsY: {
                start: p.target_control_points[0].y[0] + 1,
                stop: p.target_control_points[0].y[1],
              },
              targetControlPointsZ: {
                start: p.target_control_points[0].z[0] + 1,
                stop: p.target_control_points[0].z[1],
              },
              morphingDirection: p.direction,
              morphingParameter: {
                upper: p.upper_bound,
                lower: p.lower_bound
              },
            }))
          );
        }
      } catch (error) {
        console.error('Error reading file:', error);
      }
    };
    reader.readAsText(file);
  }
};
